import { Link } from 'react-router-dom';
import React from 'react';
import { DATI_AZIENDA } from '../pages/Privacy.jsx';

const CLOTHO_URL = 'https://clothoio.com';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-slate-950 text-slate-400">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 text-sm sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Sede
            </p>

            <p className="mt-3 font-semibold text-white">{DATI_AZIENDA.ragioneSociale}</p>
            <p className="mt-1 leading-6">{DATI_AZIENDA.indirizzo}</p>
            <p className="leading-6">{DATI_AZIENDA.comune}</p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Dati fiscali
            </p>

            <p className="mt-3 leading-6">P. IVA {DATI_AZIENDA.partitaIva}</p>
            <p className="leading-6">Società a responsabilità limitata</p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Contatti
            </p>

            <p className="mt-3 leading-6">
              <a
                href={`mailto:${DATI_AZIENDA.email}`}
                className="transition hover:text-white"
              >
                {DATI_AZIENDA.email}
              </a>
            </p>

            <p className="leading-6">
              <a href={DATI_AZIENDA.telefonoHref} className="transition hover:text-white">
                {DATI_AZIENDA.telefono}
              </a>
            </p>

            <p className="leading-6">
              <a
                href={CLOTHO_URL}
                target="_blank"
                rel="noreferrer"
                className="transition hover:text-white"
              >
                Partner tecnologico: Clotho
              </a>
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
              Note legali
            </p>

            <ul className="mt-3 space-y-1 leading-6">
              <li>
                <Link to="/privacyPolicy" className="transition hover:text-white">
                  Informativa privacy e cookie
                </Link>
              </li>
              <li>
                <Link to="/terms" className="transition hover:text-white">
                  Termini di servizio
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="transition hover:text-white">
                  Contatti
                </Link>
              </li>
              <li>
                <Link to="/login" className="transition hover:text-white">
                  Area riservata
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center gap-2 border-t border-white/10 pt-6 text-center text-xs text-slate-500 sm:flex-row sm:justify-between">
          <p>
            &copy; {new Date().getFullYear()} {DATI_AZIENDA.ragioneSociale}. Tutti i diritti
            riservati.
          </p>

          <p>Nessun cookie di profilazione. Solo archiviazione tecnica.</p>
        </div>
      </div>
    </footer>
  );
}
